// extracted by mini-css-extract-plugin
export default {"darkRow":"TableRow_darkRow__5G88C","lightRow":"TableRow_lightRow__kczPp"};